import {
	useEffect,
	useState,
	type FunctionComponent,
} from "react"

import styled from "styled-components"
import {
	Typography,
} from "@bracket/ui"

import {
	DateTime,
	Interval,
} from "luxon"

import { useChainTime, } from "@bracket/platform/hooks"


export declare type TimeIntervalProps = {
	to: string | DateTime;
	from?: string| DateTime;
};



/**
 * 
 * @param from ISO timestamp
 * @param to ISO timestamp
 * @returns 
 */
export const TimeInterval: FunctionComponent<TimeIntervalProps> = ({
	to,
	from: _from = DateTime.now().toISO(),
}) => {

	const { time, } = useChainTime();
	const [ late, setLate, ] = useState(false);
	const [ days, setDays ] = useState("");
	const [ hours, setHours, ] = useState("");
	const [ minutes, setMinutes ] = useState("");
	const [ ticked, setTicked] = useState(false);

	const onTick = () => {

		const now = DateTime.fromJSDate(time);
		const target = typeof to === "string" ? DateTime.fromISO(to) : to;
		const late = now > target;
		const inte = late ? Interval.fromDateTimes(target, now) : Interval.fromDateTimes(now, target);
		const {
			days,
			hours,
			minutes,
		} = inte.toDuration(['days', 'minutes', 'hours']);

		const daysStr = days.toString();

		let hoursString = hours.toString();
		hoursString = hoursString.length === 1 ? `0${hoursString}` : hoursString;

		let minString = minutes.toFixed(0);
		minString = minString.length === 1 ? `0${minString}` : minString;

		setHours(hoursString);
		setDays(daysStr);
		setMinutes(minString);
		setLate(late);
		setTicked(true);
	}

	useEffect(() => {
		const tick = setInterval(() => {
			onTick();
		}, 1000);
		return () => {
			clearInterval(tick);
		};
	}, [time, to]);

	if(!ticked) return null;
	return (
		<Brace>
			<Typography variant="paragraphLG" color={late ? "rgb(147, 0, 10)" : "rgb(3, 255, 143)"}>
				{late ? "-" : ""} {days}d {hours}h {minutes}m
			</Typography>
		</Brace>
	);

}


const Brace = styled.div`

`
